export default "__VITE_ASSET__78093539__"